import { AuthService } from './auth.service';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export const CHANGE_DEALERSHIP_INTERCEPTOR_CONFIGS = new InjectionToken<RegExp[]>('');

export function setChangeDealershipDomainConfigs() {
    return [
        /^https?:\/\/api\.rti(\.(dev|test|qa|stage))?\.toyota\.com(\/|$)/i,
        /^https?:\/\/asp-api(\.(dev|test|qa|stage))?\.dealer\.toyota\.com(\/|$)/i,
        /^https?:\/\/asp-(availability|catalog|employee|appointment|digital-checklist)-api(\.(dev|test|qa|stage))?\.dealer\.toyota\.com(\/|$)/i
    ];
}

@Injectable({
    providedIn: 'root'
})
export class ChangeDealershipInterceptorService implements HttpInterceptor {

    constructor(
        @Inject(CHANGE_DEALERSHIP_INTERCEPTOR_CONFIGS) private configs: RegExp[],
        private authService: AuthService
    ) {
        if (!this.configs) {
            throw new Error('ChangeDealershipInterceptorService: CHANGE_DEALERSHIP_INTERCEPTOR_CONFIGS not provided');
        }
        if (!this.authService) {
            throw new Error('ChangeDealershipInterceptorService: AuthService not provided');
        }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const matches = this.configs.some(c => c.test(req.url));
        let request = req;
        if (matches) {

            const newHeaders = this._buildAuthHeader(req.headers);

            request = req.clone({ headers: newHeaders });

        }
        return next.handle(request);
    }

    private _buildAuthHeader(currentHeaders?: HttpHeaders): HttpHeaders {
        let headers = currentHeaders || new HttpHeaders();
        const dealerCode = this.authService.getDealerIdValue();
        if (dealerCode && dealerCode !== '') {
            headers = headers.append('CurrentDealer', dealerCode);
        }
        return headers;
    }
}